export default "__VITE_ASSET__bDMztq$i__"